import { useEffect, useState } from "react";

type Align = "left" | "center" | "right";

interface Slide {
  title: string;
  subtitle: string;
  align: Align;
  image: string;
}

const gradients = ["linear-gradient(135deg,#7f1d1dcc 0%,#b91c1ccc 40%,#ef4444cc 100%)", "linear-gradient(135deg,#991b1bcc 0%,#dc2626cc 40%,#f87171cc 100%)", "linear-gradient(135deg,#450a0acc 0%,#b91c1ccc 50%,#fecaca88 100%)"];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const [images, setImages] = useState<string[]>([]);
  const [animate, setAnimate] = useState(true);

  // ✅ FETCH GAMBAR SAJA
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch("https://your-api.com/hero-images");
        const data = await res.json();

        // asumsi response: [{image: "..."}]
        const imgs = data.map((item: any) => item.image);

        setImages(imgs);
      } catch (err) {
        console.log(err);

        // fallback dummy
        setImages(["/images/bg1.jpg", "/images/bg2.jpg", "/images/bg3.jpg"]);
      }
    };

    fetchImages();
  }, []);

  // ✅ AUTO SLIDE
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides.length);
        setAnimate(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // ✅ TEXT CUSTOM MERAHPUTIH08
  const slides: Omit<Slide, "image">[] = [
    {
      title: "Semangat Merah Putih untuk Negeri",
      subtitle: "Mengangkat isu strategis bangsa melalui sudut pandang Asta Cita demi Indonesia yang lebih kuat dan berdaulat.",
      align: "left",
    },
    {
      title: "Menyuarakan Perubahan Nyata",
      subtitle: "Konten terstruktur berbasis Asta Cita untuk membangun kesadaran publik terhadap arah pembangunan nasional.",
      align: "center",
    },
    {
      title: "Informasi Berkualitas & Terarah",
      subtitle: "Menghubungkan masyarakat dengan isu nasional melalui delapan pilar utama pembangunan Indonesia.",
      align: "right",
    },
  ];

  const alignment: Record<Align, string> = {
    right: "justify-end text-right",
    left: "justify-start text-left",
    center: "justify-center text-center",
  };

  const currentImage = images[index] || "";

  // ✅ SCROLL KE TENTANG
  const handleScroll = () => {
    const el = document.getElementById("tentang");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center text-white overflow-hidden">
      {/* BACKGROUND IMAGE */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-1000"
        style={{
          backgroundImage: `url(${currentImage})`,
        }}
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/40" />

      {/* RED GRADIENT */}
      <div
        className="absolute inset-0 transition-all duration-1000"
        style={{
          background: gradients[index % gradients.length],
        }}
      />

      {/* CONTENT */}
      <div className={`relative max-w-7xl mx-auto -mt-20 px-6  w-full flex ${alignment[slides[index].align]}`}>
        <div className={`max-w-xl transition-all duration-700 ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="uppercase tracking-[0.35em] text-sm text-white/80">MERAHPUTIH08</p>

          <h1 className="text-5xl md:text-7xl font-bold mt-4 leading-tight">{slides[index].title}</h1>

          <p className="mt-6 text-lg text-white/90">{slides[index].subtitle}</p>

          {/* <button onClick={handleScroll} className="mt-8 bg-white text-red-700 font-semibold px-7 py-3 rounded-lg hover:bg-red-100 transition">
            Selengkapnya
          </button> */}
        </div>
      </div>

      {/* INDICATOR */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 flex gap-3">
        {slides.map((_, i) => (
          <div key={i} className={`h-[4px] w-16 rounded-full transition-all duration-500 ${i === index ? "bg-white" : "bg-white/40"}`} />
        ))}
      </div>
    </section>
  );
};

export default Hero;
